__turbopack_context__.v({
  "productCode": "ProductInformationSection-module-scss-module__67MD8W__productCode",
  "productDetails": "ProductInformationSection-module-scss-module__67MD8W__productDetails",
  "productDetailsAccordion": "ProductInformationSection-module-scss-module__67MD8W__productDetailsAccordion",
  "productDetailsRichText": "ProductInformationSection-module-scss-module__67MD8W__productDetailsRichText",
  "productInfoAccordionTable": "ProductInformationSection-module-scss-module__67MD8W__productInfoAccordionTable",
  "productInfoAccordionTableWrapper": "ProductInformationSection-module-scss-module__67MD8W__productInfoAccordionTableWrapper",
  "productInformationSection": "ProductInformationSection-module-scss-module__67MD8W__productInformationSection",
  "qcText": "ProductInformationSection-module-scss-module__67MD8W__qcText",
  "sizeAndFitAccordion": "ProductInformationSection-module-scss-module__67MD8W__sizeAndFitAccordion",
  "sizeAndFitContainer": "ProductInformationSection-module-scss-module__67MD8W__sizeAndFitContainer",
  "techSpecKey": "ProductInformationSection-module-scss-module__67MD8W__techSpecKey",
  "techSpecKeyNoBreak": "ProductInformationSection-module-scss-module__67MD8W__techSpecKeyNoBreak",
  "techSpecValueGroup": "ProductInformationSection-module-scss-module__67MD8W__techSpecValueGroup",
  "tooltip": "ProductInformationSection-module-scss-module__67MD8W__tooltip",
});
